export default __webpack_public_path__ + "static/media/theft.f1a84b67.svg";